import css from 'styled-jsx/css';

const styles = css.global`.league-heading{display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin-bottom:12px}.league-heading .league-title{font-family:Telegraf,sans-serif;font-size:22px;font-weight:900;margin-bottom:0}.league-heading .league-show-all{font-size:14px;font-weight:bold;color:inherit;text-decoration:underline}`;

export default styles;